<script>
export default {
  name: "SchoolLinkSource"
}
</script>

<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<style scoped>

</style>